/**
 * FacetWP
 */

// wait till all slider facets exist and listen noUiSlider update event
document.addEventListener('DOMContentLoaded', function() {
  setupSliderListeners();
});

function setupSliderListeners() {
  let foundSliders = new Set();

  const checkSliders = setInterval(() => {
    const sliders = document.querySelectorAll('.facetwp-slider');
    sliders.forEach((slider) => {
      if(!foundSliders.has(slider)) {
        slider.noUiSlider.on('update.one', function (value) {
          var minInput = slider.closest('.facetwp-facet').querySelector('.profile-slider-input-min');
          var maxInput = slider.closest('.facetwp-facet').querySelector('.profile-slider-input-max');

          if (minInput) {
            minInput.value = value[0];
          }

          if (maxInput) {
            maxInput.value = value[1];
          }
        });

        foundSliders.add(slider);
      }
    });

    // If we've found all sliders, clear the interval
    const allSliders = document.querySelectorAll('.facetwp-slider');
    if(allSliders.length === foundSliders.size) {
      clearInterval(checkSliders);
    }
  }, 100); // check every 100ms
}



// to limit the number of times the event is fired
let array = [];

document.addEventListener('facetwp-loaded', function() {

  setupSliderListeners();

  const facets = document.querySelectorAll('.facetwp-type-slider');

  facets.forEach((facet) => {

    // if facet not empty
    if (facet.children.length > 0) {

      // get data-name attribute value
      var facetName = facet.getAttribute('data-name');

      if (FWP.settings[facetName]) {
        var maxValue = FWP.settings[facetName].range.max;
        var minValue = FWP.settings[facetName].range.min;

        // set custom slider input fields default min, max and value
        facet.querySelector('.profile-slider-input-min').setAttribute('min', minValue);
        facet.querySelector('.profile-slider-input-min').setAttribute('max', maxValue);
        facet.querySelector('.profile-slider-input-min').value = minValue;
        facet.querySelector('.profile-slider-input-max').setAttribute('min', minValue);
        facet.querySelector('.profile-slider-input-max').setAttribute('max', maxValue);
        facet.querySelector('.profile-slider-input-max').value = maxValue;
      }

      // override default value if valut is set
      if (FWP.facets[facetName][0]) {
        var values = FWP.facets[facetName];
        facet.querySelector('.profile-slider-input-min').value = values[0];
        facet.querySelector('.profile-slider-input-max').value = values[1];
      }
    }
  });
});


  jQuery(document).on('click', '.facetwp-load-more', function() {
    FWP.soft_refresh = true;
    FWP.extras.per_page = FWP.settings.pager.total_rows;
    FWP.refresh();

  });

 (function($) {
  document.addEventListener('facetwp-loaded', function() {

    // get all active facets
    const activeFacets = FWP.settings.num_choices;

    Object.keys(activeFacets).forEach(key => {

      if (activeFacets[key] !== 0) {

        // show only sort options that are needed
        var profile_sort = document.querySelector('.facetwp-facet-profile_sort select');

        // if profile_sort is not found, return
        if (!profile_sort) return;

        for (i=0; i<profile_sort.options.length;i++) {

          if (profile_sort.options[i].value.includes(key)) {
            profile_sort.options[i].classList.add('show-option-item');
          }
        }

        // // move slider labels
        // var facet_header = document.querySelector('.facetwp-facet-' + key + ' strong');
        // var facet_label = document.querySelector('.facetwp-facet-' + key + ' .facetwp-slider-label');

        // facet_header.append(facet_label);
      }
    });

    if ( FWP.facets['tuotteet_archive'] ) {

      var current_term_name = FWP.facets['tuotteet_archive'][0];

      // show product image by current cat
      // console.log(current_term_name);

      const category_images = document.querySelectorAll('.category-images');

      if (category_images) {
        category_images.forEach((item) => {
          const images = item.querySelectorAll('img');

          images.forEach((image) => {

            if (image.getAttribute('data-cat-image') == current_term_name) {

              images.forEach((img) => {
                img.style.display = "none";
              });

              image.style.display = "block";
            } else {

              if (image.hasAttribute('data-cat-image')) {
                image.style.display = "none";
              }
            }

          });
        });
      }

      // show current taxonomy term description based on facet selected in taxonomy-tuotekategoria
      jQuery('.facetwp-term').removeClass('show');

      if(current_term_name) {
        var current_term = jQuery('.facetwp-category-term-' + current_term_name );
        jQuery(current_term).addClass('show');
      }
    }

   });
})(jQuery);

// facetwp henkilot
document.addEventListener('facetwp-loaded', function() {

  let parents = document.querySelectorAll('.facetwp-facet-henkilot .facetwp-radio');

  if (parents.length > 0) {
    // remove disable class from all parents
    parents.forEach((parent) => {

      if (parent.classList.contains('checked')) {
        parent.classList.add('disabled');
      } else {
        parent.classList.remove('disabled');
      }
    });
  }

  // hide facetgroups that are not selected when not using search facet
  if (FWP.facets.henkilot_ala && FWP.facets.henkilot_haku.length === 0) {

    // hide term groups that is not currentlu selected
    let term_groups = document.querySelectorAll('.contact-persons__term-group');

    term_groups.forEach((group) => {
      let group_name = group.getAttribute('data-term-group');

      // if group has data-term-group attribute
      if (group_name) {
        if (FWP.facets['henkilot_ala'][0] !== group_name) {
          group.style.display = 'none';
        }
      }
    });
  }


  // reset facets
  if (parents.length > 0 && null !== FWP.active_facet) {
    let active = FWP.active_facet.nodes[0];
    let facet = active.getAttribute('data-name');

    if (facet === 'henkilot') {
      FWP.facets['henkilot_ala'] = [];
      FWP.facets['henkilot_haku'] = [];
      FWP.fetchData();
      FWP.setHash();
    }

    // reset facets henkilot and henkilot_ala when using henkilot_haku
    if (FWP.facets['henkilot'].length != 0 && facet === 'henkilot_haku') {
      // FWP.facets['henkilot'] = [];
      // FWP.facets['henkilot_ala'] = [];
    }

    if (facet === 'henkilot_haku') {

      if (0 == FWP.settings.pager.total_rows) {
        FWP.facets['henkilot'] = [];
        FWP.facets['henkilot_ala'] = [];
      }

      if (0 < FWP.settings.pager.total_rows) {
        FWP.facets['henkilot_ala'] = [];
      }

      FWP.fetchData();
      FWP.setHash();
    }
  }

  // if contact-persons__facets exists
  if (document.querySelector('.contact-persons__facets')) {
    var template = document.querySelector('.contact-persons .facetwp-template');
    var facet_child = document.querySelector('.contact-persons__facets__subcategory');
    var facet_search = document.querySelector('.contact-persons__facets__search');

    if (FWP.facets.henkilot.length > 0) {
      facet_child.classList.add('visible');
    } else {
      facet_child.classList.remove('visible');
    }

    if (FWP.facets.henkilot.length > 0) {
      facet_search.classList.add('hidden');

      // add displan none with delay for animations to work
      setTimeout(() => {
        facet_search.style.display = 'none';
      }, 250);

    } else {
      facet_search.classList.remove('hidden');
      facet_search.style.display = 'block';
    }

    // show template if henkilot_ala or henkilot_haku is selected
    if (FWP.facets.henkilot_ala.length > 0 || FWP.facets.henkilot_haku.length > 0) {
      template.classList.add('visible');
    } else {
      template.classList.remove('visible');
    }
  }

});
(function($) {
    $(document).on('facetwp-loaded', function() {
        // Vieritä näkymä tuotelistauksen alkuun
        const productList = document.querySelector('#tuotteet'); // Korvaa oikealla luokalla
        if (productList) {
            productList.scrollIntoView({ behavior: 'smooth' });
        } else {
            // Varmistetaan, että fallbackina vieritetään ylös
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    });
})(jQuery);